import React from "react";
import { Dialog, makeStyles } from "@material-ui/core";

const FlightInvoiceButton = (props) => {
    const classes = useStyles();

    return (
        <Dialog
            open={props.openInvoice}
            onClose={props.handleClose}
            PaperProps={{
                className: classes.dialogPaper,
            }}
        >
            <div className="flex-box justify-content-center invoice-type-select-div form-element">
                <button
                    className="btn btn-submit"
                    onClick={() => props.goToInvoice("flight-user")}
                >
                    User Invoice
                </button>
                <button
                    className="btn btn-submit"
                    onClick={() => props.goToInvoice("flight-agent")}
                >
                    Agent Invoice
                </button>
            </div>
        </Dialog>
    );
};

export default FlightInvoiceButton;

const useStyles = makeStyles((theme) => ({
    dialogPaper: {
        "& .ticket-delivery-card": {
            position: "relative"
        },
        "& button, .dialog-close-button": {
            cursor: "pointer"
        },
        "& .dialog-close-button": {
            position: "absolute",
            top: 0,
            right: 0,
            height: 20,
            width: 20,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        // "& .flex-box": {
        //     display: "flex"
        // },
        // "& .justify-content-center": {
        //     justifyContent: "center"
        // },
        // "& .invoice-type-select-div": {
        //     gap: 10
        // },
        // "& .form-element": {}
    }
}));
